<template>
  <div class="content-panel">
    <a-input-search
      v-model="dimName"
      style="margin-bottom: 8px"
      placeholder="请选择设备"
      @search="queryDictData"
      @pressEnter="queryDictData"
    />
    <a-spin :spinning="loading" wrapperClassName="spin">
      <a-card :bordered="false">
        <a-tree
          style="height:100%"
          v-if="treeData.length > 0"
          :defaultCheckedKeys="defaultSelectedKeys"
          :defaultExpandedKeys="defaultSelectedKeys"
          :defaultSelectedKeys="defaultSelectedKeys"
          :selectedKeys="selectedKeys"
          :treeData="treeData"
          :draggable="false"
          @expand="onExpand"
          @select="select"
        >
          <template slot="custom" slot-scope="item">
            <span class="treeCompanyName">{{ item.name }}</span>
          </template>
        </a-tree>
      </a-card>
    </a-spin>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { getDeviceTypeTree } from '@/api/deviceType'
export default {
  name: 'OrgTree',
  components: {
  },
  computed: {
    ...mapGetters(['subcompanycode'])
  },
  data () {
    return {
      expandedKeys: [],
      loading: false,
      dimName: '',
      treeData: [],
      defaultSelectedKeys: ['000000'],
      selectedKeys: ['000000'],
      bukrs: ''
    }
  },
  created () {
    // 获取资产类型
    this.getAssetType()
  },
  watch: {
    subcompanycode (newValue) {
      console.log(newValue)
      // this.getAssetType()
    }
  },
  methods: {
    ...mapActions(['handleAnlkl']),
    onExpand (expandedKeys) {
      this.expandedKeys = expandedKeys
    },
    formateData (arr, id) {
      const f_arr = []
      const self = this
      if (arr && arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          const item = JSON.parse(JSON.stringify(arr[i]))
          item.key = item.code
          item.scopedSlots = { title: 'custom' }
          if (item.children && item.children.length) {
            item.children = self.formateData(item.children)
          }
          f_arr.push(item)
        }
      }
      return f_arr
    },
    // 获取资产类型
    async getAssetType () {
      this.loading = true
      const data = { name: this.dimName.trim() }
      const res = await getDeviceTypeTree(data)
      if (res.status === 0) {
        this.loop(res.data)
        this.treeData = [
          {
            key: '000000',
            scopedSlots: { title: 'custom' },
            name: '设备',
            code: '设备分类',
            children: res.data
          }
        ]
        if (res.data[0]) {
          this.defaultSelectedKeys = [this.treeData[0].key]
        }
      } else {
        this.$message.error(res.info.message)
      }
      this.loading = false
      // const data = {
      //   pCode: 'zcfl',
      //   dimName: this.dimName
      // }
      // this.loading = true
      // getAssetTypeTreeList(data).then(res => {
      //   if (res.status === 0) {
      //     if (res.data.length > 0) {
      //       res.data.map(item => {
      //         item.scopedSlots = { title: 'custom' }
      //         item.children = this.formateData(item.children, item.id)
      //       })
      //     }
      //     this.treeData = [
      //       {
      //         key: '000000',
      //         scopedSlots: { title: 'custom' },
      //         name: '资产',
      //         code: '资产分类',
      //         children: res.data
      //       }
      //     ]
      //     this.loading = false
      //   } else {
      //     this.$message.error(res.info.message)
      //     this.loading = false
      //   }
      // })
    },
    loop (data) {
      for (let i = 0; i < data.length; i++) {
        data[i].scopedSlots = {
          title: 'custom'
        }
        if (data[i].children) {
          this.loop(data[i].children)
        }
      }
    },
    // 调用父组件的获取使用部门数据方法
    select (data, info) {
      if (data.length > 0) {
        this.selectedKeys = data
        let codeData = ''
        if (info.selectedNodes.length === 1) {
          codeData = info.selectedNodes[0].data.props.code
        }
        this.handleAnlkl(codeData)
      }
    },
    // 搜索设备分类
    queryDictData () {
      this.getAssetType()
    }
  }
}
</script>
<style lang="less">
.ant-modal-body {
  #chart-container {
    overflow-x: auto;
  }
}

.ant-tooltip {
  z-index: 1020;
}
.content-panel {
  height: 100%;
  //padding-bottom: 20px;
  .action-btn-line {
    display: flex;
    justify-content: space-between;
  }

  .ant-tree-title {
    width: 100%;

    & > span {
      // width: 90px;
      display: inline-block;
      white-space: pre-line !important;
    }
  }
  .title {
    float: left;
  }

  .ant-card-body {
    padding: 0;

    :global {
      .ant-tree {
        line-height: 3;

        .ant-tree-node-content-wrapper,
        .ant-tree-switcher {
          height: auto;
          margin-top: 5px;
          margin-bottom: 5px;
        }
        .ant-tree-node-content-wrapper:hover {
          background: transparent;
        }
        .ant-tree-treenode-selected {
          background: #e6f7ff;
          height: auto !important;
          .ant-tree-node-selected {
            background: transparent;
          }
        }

        .ant-tree-child-tree {
          background: #fff;
        }
        li {
          position: relative;
          line-height: 3;
          padding-bottom: 0;
        }
      }
      .ant-btn {
        margin-bottom: 8px;
      }
    }

    .icon-panel {

      .anticon-plus,
      .anticon-setting,
      .anticon-edit,
      .anticon-delete {
        margin-left: 5px;
        color: #1890ff;
      }
    }
  }
}
/deep/.ant-tree-treenode-switcher-close  {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 0 4px 0 !important;
  height: auto;
  margin: 0 !important;
}
/deep/.ant-tree-node-content-wrapper-close {
  height: auto;
}
/deep/.ant-tree-treenode-switcher-open {
  padding: 0 !important;
}
/deep/.ant-tree-node-content-wrapper-open {
  margin: 0 !important;
  height: auto;
}
/deep/.ant-tree-node-content-wrapper {
  margin: 0 !important;
  height: auto;
}
/deep/.ant-tree-node-selected {
  height: auto;
}
.content-panel .ant-tree li {
  margin: 0!important;
  padding: 0!important;
  height: auto;
}
.content-panel .ant-tree li .ant-tree-child-tree {
  margin: 0!important;
}
/deep/.ant-tree li {
  margin: 0!important;
  padding: 0!important;
}
.spin {
  height: calc(100% - 40px);
  overflow: auto;
}
.treeCompanyName {
  font-size: 14px;
}
</style>
